import PropTypes from 'prop-types';
import InvoiceAlternativesTabSwitcher from './InvoiceAlternativesTabSwitcher';
import { InvoiceTableContainer } from './OrderInvoiceComponents/InvoiceTableContainer/InvoiceTableContainer';
import {
  InvoiceItemsSectionBlock,
  InvoiceItemsSectionHeader,
  InvoiceItemsSectionTitle,
} from './OrderInvoice.style';

export const selfInsuranceBlockTabsContainerStyle = {
  margin: '12px 16px 0',
  width: '100%',
  maxWidth: 304,
};

/**
 * Optional section title + optional alternatives tab switcher + invoice table + optional footer.
 */
const InvoiceItemsBlock = ({ title, switcher, tableProps, footer }) => {
  const switcherNode =
    switcher != null ? (
      <InvoiceAlternativesTabSwitcher
        enabled={switcher.enabled}
        value={switcher.value}
        onChange={switcher.onChange}
        tabsContainerStyle={switcher.tabsContainerStyle}
      />
    ) : null;

  return (
    <InvoiceItemsSectionBlock>
      {title != null && title !== '' && (
        <InvoiceItemsSectionHeader>
          <InvoiceItemsSectionTitle>{title}</InvoiceItemsSectionTitle>
        </InvoiceItemsSectionHeader>
      )}
      {switcherNode}
      <InvoiceTableContainer {...tableProps} />
      {footer}
    </InvoiceItemsSectionBlock>
  );
};

InvoiceItemsBlock.propTypes = {
  title: PropTypes.string,
  switcher: PropTypes.shape({
    enabled: PropTypes.bool,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    tabsContainerStyle: PropTypes.object,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  tableProps: PropTypes.object.isRequired,
  footer: PropTypes.node,
};

InvoiceItemsBlock.defaultProps = {
  title: null,
  switcher: null,
  footer: null,
};

export default InvoiceItemsBlock;
